export enum EnvironmentalBadge {
  None = 0,
  Red = 2,
  Yellow = 3,
  Green = 4
}
